'use client'

import type { UserLawn } from '@/hooks/use-default-lawn'

interface LawnPrefillBannerProps {
  lawns: UserLawn[]
  selectedLawnId: string | null
  onSelect: (id: string) => void
}

export function LawnPrefillBanner({ lawns, selectedLawnId, onSelect }: LawnPrefillBannerProps) {
  if (lawns.length === 0) return null

  const selected = lawns.find((lawn) => lawn.id === selectedLawnId) ?? lawns[0]

  return (
    <div className="mb-4 flex flex-col gap-2 rounded-lg border border-green-200 bg-green-50/70 px-4 py-3 text-sm text-green-950 sm:flex-row sm:items-center sm:justify-between">
      <p className="font-semibold">Using {selected?.name || 'saved lawn'}</p>
      {lawns.length > 1 ? (
        <label className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-green-900">
          Lawn
          <select
            value={selected?.id ?? ''}
            onChange={(event) => onSelect(event.target.value)}
            className="min-h-11 rounded-md border border-green-200 bg-white px-3 text-sm font-medium normal-case tracking-normal text-green-950"
          >
            {lawns.map((lawn) => (
              <option key={lawn.id} value={lawn.id}>
                {lawn.name || 'Saved lawn'}
              </option>
            ))}
          </select>
        </label>
      ) : null}
    </div>
  )
}
